import { render, staticRenderFns } from "./UpdateItemsModal.vue?vue&type=template&id=3bfbbd86&"
import script from "./UpdateItemsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateItemsModal.vue"
export default component.exports